// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MoParticipantsSyncModal_wrapper__3oZfq"};